/**
 * Forms Widget Individual Form Template View
 *
 * @package Ninja Forms
 * @subpackage Dashboard
 * @copyright (c) 2017 WP Ninjas
 * @since 3.2
 */
define( 'views/widgets/forms/newFormTemplate',[], function() {
    var view = Marionette.View.extend( {
        template: "#tmpl-nf-widget-forms-template",
    } );
    return view;
} );

